export default "images/technicalTtitle.png";